import { Component, OnInit, Input, QueryList, ViewChildren } from '@angular/core';
import { CCategoryAnswerDto, CAnswerDto, FarmerCropQuantityDto, FarmerNutrientRecommendationQuantityDto, CAnswerLevelEnum, CBehaviorTypeEnum, CCertificationStatusEnum, CertificationAnswerServiceServiceProxy, CAnswerTypeEnum, FarmerDto, FarmerNutrientSourceQuantityDto } from '@shared/service-proxies/service-proxies';
import { CertificationCategoryComponent } from '../certification-category/certfication-category.component';
import { AccordionComponent } from 'src/app/components/accordion/accordion/accordion.component';
import { AccordionPanelComponent } from 'src/app/components/accordion/accordion-panel/accordion-panel.component';
import { CertificationPage } from '../certification.page';
import { AlertController, Platform } from '@ionic/angular';

@Component({
  selector: 'app-certification-answer',
  templateUrl: './certification-answer.component.html',
  styleUrls: ['./certification-answer.component.scss'],
})
export class CertificationAnswerComponent implements OnInit {
  id: number;
  answer: CAnswerDto;

  @Input() isView: boolean = false;

  @Input() certificationId: number;
  @Input() farmerCrops: FarmerCropQuantityDto[]=[];
  @Input() farmerNutrientSources: FarmerNutrientSourceQuantityDto[]=[];

  @Input() category: CCategoryAnswerDto;
  @Input() categoryQuestion: CCategoryAnswerDto;
  @Input() answerLevels: number[];
  @Input() answerLevel: number;
  @Input() farmer: FarmerDto;
  @Input() farmerCrop: FarmerCropQuantityDto;
  @Input() farmerNutrientRecommendations: FarmerNutrientRecommendationQuantityDto[]=[];
  @ViewChildren('categoryLevelPanels') categoryLevelPanels: QueryList<CertificationCategoryComponent>;
  @Input() accordion: AccordionComponent;
  @Input() panel: AccordionPanelComponent;
  @Input() certificationPage: CertificationPage;
  answerValue: any;
  oldAnswerValue: any;

  isIOS: boolean;

  constructor(
    private answerService: CertificationAnswerServiceServiceProxy,
    public alertController: AlertController,
    public platform: Platform
  ) {
    this.isIOS = platform.is('ios');
  }

  ngOnInit() {}

  ngAfterViewInit(){ // ngOnInit() {
    if (this.categoryQuestion) {
      let hasAnswer = false;
      if (this.categoryQuestion.answers) {
        if (
          this.answerLevel == CAnswerLevelEnum._0
        ) {
          if (
            this.categoryQuestion.behaviorTypeId == CBehaviorTypeEnum._3 &&
            this.categoryQuestion.answers.owned &&
            this.farmerCrop &&
            this.categoryQuestion.answers.owned.find(x => x.objectId == this.farmerCrop.cropId)
          ) {
            hasAnswer = true;
            this.answer = this.categoryQuestion.answers.owned.find(x => x.objectId == this.farmerCrop.cropId);
          } else if (
            this.categoryQuestion.behaviorTypeId != CBehaviorTypeEnum._3 &&
            this.categoryQuestion.answers.owned &&
            this.categoryQuestion.answers.owned[0]
          ) {
            hasAnswer = true;
            this.answer = this.categoryQuestion.answers.owned[0];
          }
        } else if (
          this.answerLevel == CAnswerLevelEnum._1
        ) {
          if(
            this.categoryQuestion.behaviorTypeId == CBehaviorTypeEnum._3 &&
            this.categoryQuestion.answers.rented &&
            this.farmerCrop &&
            this.categoryQuestion.answers.rented.find(x => x.objectId == this.farmerCrop.cropId)
          ) {
            hasAnswer = true;
            this.answer = this.categoryQuestion.answers.rented.find(x => x.objectId == this.farmerCrop.cropId);
          } else if(
            this.categoryQuestion.behaviorTypeId != CBehaviorTypeEnum._3 &&
            this.categoryQuestion.answers.rented &&
            this.categoryQuestion.answers.rented[0]
          ) {
            hasAnswer = true;
            this.answer = this.categoryQuestion.answers.rented[0];
          }
        }
      }
      if (hasAnswer) {
        this.id = this.answer.id;
        this.answerValue = this.answer.answer;
        this.oldAnswerValue = this.answerValue;
      } else {
        if (
          this.categoryQuestion.id == 30 &&
          this.farmerNutrientRecommendations &&
          this.farmerNutrientRecommendations.find(x => x.nutrientRecommendationIsFullService)
        ) { // 3-4 years
          if (this.answerLevel == CAnswerLevelEnum._0) {
            this.answerValue = this.farmerNutrientRecommendations.find(x => x.nutrientRecommendationIsFullService).ownedQuantity;
            this.oldAnswerValue = this.answerValue;
          } else if (this.answerLevel == CAnswerLevelEnum._1) {
            this.answerValue = this.farmerNutrientRecommendations.find(x => x.nutrientRecommendationIsFullService).rentedQuantity;
            this.oldAnswerValue = this.answerValue;
          }
        }
      }
    }
  }
  async saveAnswer(event, didAcceptQuantityOver) {
    const answerValue = this.isIOS && this.categoryQuestion.answerTypeId == 1 ? event : this.answerValue;
    if (
      !didAcceptQuantityOver &&
      // this.categoryQuestion.answerTypeId == 1 && idk ||
      this.categoryQuestion.answerTypeId == 2
    ) {
      if (!this.isBonusQuestion()) {
        if (
          this.isCropQuestion() ? answerValue > this.farmerCrop.quantity :
          (this.isManureApplication() || this.isBiosolidsApplication() || this.isOtherOrganic()) ?
          (
            this.answerLevel == CAnswerLevelEnum._0 ? answerValue > this.getFarmerNutrientSource().ownedQuantity :
            this.answerLevel == CAnswerLevelEnum._1 ? answerValue > this.getFarmerNutrientSource().rentedQuantity : false // idk lol
          ) :
          (
            this.answerLevel == CAnswerLevelEnum._0 ? answerValue > this.farmer.ownedAcres :
            this.answerLevel == CAnswerLevelEnum._1 ? answerValue > this.farmer.rentedAcres : false // idk lol
          )
        ) {
          const alert = await this.alertController.create({
            header: 'Certification Question Confirmation',
            message: 'You have submitted more acres for this question than you have put on your farmer profile. Is this correct?',
            buttons: [
              {
                text: 'No',
                role: 'cancel',
                cssClass: 'secondary',
                handler: (blah) => {
                  this.answerValue = null;
                }
              }, {
                text: 'Yes',
                handler: () => {
                  this.saveAnswer(event, true);
                }
              }
            ]
          });
          await alert.present();
          return;
        } else {
          this.saveAnswer(event, true);
          return;
        }
      }
    }
    let doSave = true;
    const request = this.answer ? this.answer : new CAnswerDto();
    request.answer = answerValue;
    // if (answerValue == null || answerValue === '') {
    //   doSave = false;
    // }
    if (this.oldAnswerValue == answerValue) {
      doSave = false;
    }
    request.answerLevelId = this.answerLevel;
    request.categoryId = this.categoryQuestion.id;
    request.certificationId = this.certificationId;
    if (
      answerValue != null && 
      this.categoryQuestion.behaviorTypeId == CBehaviorTypeEnum._3 &&
      this.farmerCrop
    ) {
      request.objectId = this.farmerCrop.cropId;
      // if (this.categoryQuestion.answerTypeId == CAnswerTypeEnum._1) {
      //   request.answer = event.detail.checked;
      // }
      doSave = true;
    }
    if (doSave) {
      if (
        request.id > 0 &&
        (
          request.answer == null ||
          request.answer == ''
        )
      ) {
        this.answerService.delete(request.id).subscribe(() => {
          this.id = null;
          this.updateCategoryQuestionAnswer(null); // do before in case it exists
          this.answer = null;
          this.answerValue = null;
          this.oldAnswerValue = null;
        });
      } else {
        this.answerService.save(request).subscribe(answer => {
          this.id = answer.id;
          this.answer = answer;
          this.updateCategoryQuestionAnswer(answer);
          this.oldAnswerValue = answerValue;
          // ok we saved an answer.. if new cert we need to say it's in progress now
          if (this.certificationPage.certification.statusId == CCertificationStatusEnum._0) {
            this.certificationPage.setInProgress();
          }
        });
      }
    }
  }

  updateCategoryQuestionAnswer(answer: CAnswerDto) {
    if (
      this.answerLevel == CAnswerLevelEnum._0
    ) {
      if (!this.categoryQuestion.answers.owned) {
        this.categoryQuestion.answers.owned = [];
      }
      if (answer == null && this.answer != null && this.categoryQuestion.answers.owned.find(x => x.id == this.answer.id)) {
        const index = this.categoryQuestion.answers.owned.findIndex(x => x.id == this.answer.id);
        this.categoryQuestion.answers.owned.splice(index, 1);
      } else if (!this.categoryQuestion.answers.owned.find(x => x.id == answer.id)) {
        this.categoryQuestion.answers.owned.push(answer);
      } else {
        const index = this.categoryQuestion.answers.owned.findIndex(x => x.id == answer.id);
        this.categoryQuestion.answers.owned.splice(index, 1, answer);
      }
    } else if (
      this.answerLevel == CAnswerLevelEnum._1
    ) {
      if (!this.categoryQuestion.answers.rented) {
        this.categoryQuestion.answers.rented = [];
      }
      if (answer == null && this.answer != null && this.categoryQuestion.answers.rented.find(x => x.id == this.answer.id)) {
        const index = this.categoryQuestion.answers.rented.findIndex(x => x.id == this.answer.id);
        this.categoryQuestion.answers.rented.splice(index, 1);
      } else if (!this.categoryQuestion.answers.rented.find(x => x.id == answer.id)) {
        this.categoryQuestion.answers.rented.push(answer);
      } else {
        const index = this.categoryQuestion.answers.rented.findIndex(x => x.id == answer.id);
        this.categoryQuestion.answers.rented.splice(index, 1, answer);
      }
    }
  }

  getFarmerNutrientSource () {
    switch(this.categoryQuestion.parentId) {
      case 7: // Manure Application Recommendation
      case 14: // Manure Application
        return this.farmerNutrientSources.find(x => x.nutrientSourceId == 2);
      case 8: // Biosolids Application Recommendation
      case 15: // Biosolids Application
        return this.farmerNutrientSources.find(x => x.nutrientSourceId == 3);
      case 9: // Other Organic Nutrient Sources
      case 16: // Other Organic Sources
        return this.farmerNutrientSources.find(x => x.nutrientSourceId == 6);
      default: return null;
    }
  }

  getCropToggleAnswerValue() {
    if (
      this.answer &&
      this.farmerCrop &&
      this.answer.objectId == this.farmerCrop.cropId
    ) {
      return this.answer.answer;
    } else {
      return null;
    }
  }

  openAccordion(event) {
    console.log(event);
    // if (event.srcElement.localName == 'ion-toggle') {

    // } else {
      // this.certificationPage.collapseExcept(this.panel);
    this.certificationPage.collapseExcept(this.category);
    // }
  }

  isCropQuestion() {
    return [
      10, // Commercial Phosphorus Fertilizer Recommendations
      11, // Commercial Nitrogen Fertilizer Recommendations
      12, // Commercial Phosphorus Fertilizer Application
      13, // Commercial Nitrogen Fertilizer Application
      17  // Tillage
    ].indexOf(this.categoryQuestion.parentId) > -1;
  }
  isManureApplication() {
    return [
      7,  // Manure Application Recommendation
      14, // Manure Application
    ].indexOf(this.categoryQuestion.parentId) > -1;
  }
  isBiosolidsApplication() {
    return [
      8,  // Biosolids Application Recommendation
      15, // Biosolids Application
    ].indexOf(this.categoryQuestion.parentId) > -1;
  }
  isOtherOrganic() {
    return [
      9,  // Other Organic Nutrient Sources
      16, // Other Organic Sources
    ].indexOf(this.categoryQuestion.parentId) > -1;
  }

  isBonusQuestion() {
    return [
      19, // Grassed Waterways
      20, // Grade Stabilization Structures
      21, // Blind Inlets
      22, // Drainage Water Control Structures
      23, // Filter Strips or Buffer Strips
      24, // Wetlands
      25, // Two-Stage Ditch or Natural Stream Channel Restoration
      26, // Denitrifying Bioreactor
      27  // Phosphorus Removal Bed (P-filter)
    ].indexOf(this.categoryQuestion.parentId) > -1;
  }

}
